import React from 'react';
import './Team.css';


import Elon from '../assets/Team/Elon.jpg';
import mark from '../assets/Team/mark.jpeg';
import Steve from '../assets/Team/Steve.jpeg';
function Team() {
  return (
    <div className="team-container">
      <h2 className="team-title">Meet The Team</h2>
      <p className="team-subtitle">
        Driven by purpose. United by vision. Meet the hearts behind the work.
      </p>
       {/* Testing test  test*/}
      <div className="team-grid">
        {/* Elon */}
        <div className="team-card">
          <div className="hexagon">
            <img src={Elon} alt="Elon" />
          </div>
          <h3 className="team-name">Elon</h3>
          <p className="team-quote">
            "I'm not going to kill you. I want you to do me a favor. I want you
            to tell all your friends about me." This quote emphasizes Batman's
            role as a symbol of fear for Gotham's criminals.
          </p>
        </div>

        {/* Divider */}
        <div className="divider" />

        {/* Mark */}
        <div className="team-card">
          <div className="hexagon">
            <img src={mark} alt="Mark" />
          </div>
          <h3 className="team-name">Mark</h3>
          <p className="team-quote">
            "You will give people an ideal to strive towards, they will race
            behind you, they will stumble, they will fall, but in time they
            will join you, in time you will help them accomplish wonders."
            - Jor-El
          </p>
        </div>

        {/* Divider */}
        <div className="divider" />

        {/* Steve */}
        <div className="team-card">
          <div className="hexagon">
            <img src={Steve} alt="Steve" />
          </div>
          <h3 className="team-name">Steve</h3>
          <p className="team-quote">
            "You're an amazing creature, Spider-Man, you and I are not so
            different. Well... to each his own. I chose my path, you chose the
            path of the hero, and they found you amusing for a while, the people
            of this city"
          </p>
        </div>
      </div>
    </div>
  );
}

export default Team;